import { ParagraphMD, ParagraphSM, Text } from '@/atoms/Text'
import { MomentUserStory } from '@/services/MomentsService/types'
import { useTranslate } from '@/utils/translate/translate-client'
import { StoryActions } from './StoryActions'

interface Props {
  story?: MomentUserStory
  projectName?: string
}

export const TextStory: React.FC<Props> = ({ story, projectName = 'Angel Studios' }) => {
  const { t } = useTranslate('watch')

  if (!story) return null

  const storyCreatedTimeline = (timestamp: string | undefined | null) => {
    if (!timestamp) {
      return ''
    }
    const createdAt = new Date(parseInt(timestamp))
    const now = new Date()
    const differenceInSeconds = Math.floor((Number(now) - Number(createdAt)) / 1000)
    const daysDifference = Math.floor(differenceInSeconds / 86400)

    if (differenceInSeconds < 60) {
      return `${differenceInSeconds} seconds ago`
    } else if (differenceInSeconds < 3600) {
      return `${Math.floor(differenceInSeconds / 60)} minutes ago`
    } else if (differenceInSeconds < 86400) {
      return `${Math.floor(differenceInSeconds / 3600)} hours ago`
    } else if (daysDifference < 30) {
      return `${daysDifference} days ago`
    } else if (daysDifference < 365) {
      const monthsDifference = Math.floor(daysDifference / 30)
      return `${monthsDifference} month${monthsDifference > 1 ? 's' : ''} ago`
    } else {
      return 'over 1 year ago'
    }
  }

  const fanOfShow = t('fanOf', 'A Fan of')
  const defaultProfileImage =
    'https://images.angelstudios.com/image/upload/w_200,h_200,b_rgb:7B7979/l_text:Roboto_75_bold:A,co_rgb:FFFFFF/profiles/default_profile.png'

  const getUserProfile = (story: MomentUserStory) => {
    const isDeletedUser = (value: string | null | undefined) =>
      value?.toLocaleLowerCase().includes('deleted') || value === null || value === undefined

    const firstName = isDeletedUser(story?.user?.profile?.firstName) ? fanOfShow : story?.user?.profile?.firstName
    const lastName = isDeletedUser(story?.user?.profile?.lastName) ? projectName : story?.user?.profile?.lastName
    const image = isDeletedUser(story?.user?.profile?.image) ? defaultProfileImage : story?.user?.profile?.image

    return { firstName, lastName, image }
  }

  const userProfile = getUserProfile(story)

  return (
    <div className="relative my-4 grid grid-cols-[42px_auto] pr-3">
      <div className="h-8 w-8">
        <img src={userProfile?.image ?? defaultProfileImage} alt="" className="h-8 w-8 rounded-full" />
      </div>
      <div>
        <div className="flex flex-wrap justify-between">
          <ParagraphMD>
            {userProfile?.firstName} {userProfile?.lastName}
          </ParagraphMD>
          <Text className="photon-paragraph-sm ml-1 justify-self-end !font-light" color="white">
            {storyCreatedTimeline(story?.createdAt)}
          </Text>
        </div>
        <div>
          <ParagraphSM color="gray-200" className="my-1 font-[350]">
            {story.text}
          </ParagraphSM>
        </div>
        <StoryActions story={story} />
      </div>
    </div>
  )
}
